import type { JSX } from "react";

import { InviteTeammatesListItem } from "app/components/SharingModal/components/InviteTeammatesListItem/InviteTeammatesListItem";
import type { IUserInfoExtended } from "app/components/SharingModal/types";

export const USERS_TO_DISPLAY = 5;
export const USERS_LIST_HEIGHT = 40;

export const getInviteTeammatesListItems = <T extends IUserInfoExtended>(
    users: T[],
    onSelectUser: (item: T) => () => Promise<void>,
): JSX.Element[] =>
    users.map((user) => (
        <InviteTeammatesListItem
            key={user.id}
            email={user.email}
            name={user.text}
            isInvite={user.isInvite}
            iconName="employees"
            onClick={onSelectUser(user)}
        />
    ));
